import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'piqet-angular-incorrect-data-notification',
  template: `
    <div
      class="alert alert-notification alert-dismissible fade show d-flex justify-content-between align-items-center rounded-0"
      role="alert"
    >
      <div>
        {{ message }}
      </div>
      <div *ngIf="isShowButton && !!buttonName">
        <button
          type="button"
          class="btn btn-sm alert-btn-update me-2 p-2"
          (click)="triggerEolAction()"
        >
          {{ buttonName }}
        </button>
      </div>
    </div>
  `,
})
export class IncorrectDataNotificationComponent {
  @Input() buttonName: string = '';
  @Input() message: string = '';
  @Input() isShowButton: boolean = true;
  @Input() componentName: string = '';
  @Output() eolAction = new EventEmitter<string>();

  triggerEolAction() {
    this.eolAction.emit(this.componentName);
  }
}
